// jQuery(document).ready(function() {
//    var $ = jQuery.noConflict();
//    view_checklist(42);
//    setTimeout(function() {
//        $('a#link-to-prints').click();
//    },500);
// });
function add_checklist(afterAdd, extraData) {
    const $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/checklist/add',
        onOpen: function (elm, popup) {
            add_fields_to_form(elm.find('form'), extraData);
            init_checklist_selectors(elm, popup);

            elm.find('form').ajaxFormSubmit(function(data){
                popup.close();
                if(afterAdd === undefined) {
                    $('body').append('<div class="i-am-loading"></div>');
                    reload_location_if_needed();
                } else {
                    $('body').doneLoading();
                    afterAdd(data, elm, popup);
                }
            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]),function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}
function init_checklist_selectors(elm, popup) {
    const $ = jQuery.noConflict();

    elm.find('[data-search-table-selector]').searchTableSelector();
    elm.find('[data-add-item]').click(function() {
        setTimeout(function() {
            elm.find('[data-search-table-selector]').searchTableSelector();
        }, 100);
    });

    elm.find('.repeats-wrapper select.type-selector').change(function() {
        const wrapper = $(this).parents('.repeat-item');
        const typeDependantInput = wrapper.find('.type-dependant-input');
        const value = $(this).val();

        typeDependantInput.each(function() {
            const inputWrapper = $(this);
            const types = inputWrapper.attr('data-types').split(',');
            const show = types.indexOf(value) >= 0;

            inputWrapper.toggle(show);

            if (show === true) {
                inputWrapper.find(':input').removeAttr('disabled');
            } else {
                inputWrapper.find(':input').attr('disabled', 'disabled');
            }
        });

    }).trigger('change');
}
function delete_checklist(id, name) {
    const $ = jQuery.noConflict();
    name = decodeURI(name);
    const isOnDetails = is_on_checklist_details();
    confirm("Weet u zeker dat u \""+name+"\" wilt verwijderen?", function() {
        $('body').isLoading('dark');
        $.ajax({
            url: "/checklist/delete/" + id,
            type: "POST",
            success: function(data) {
                $('[data-object-type=\'checklist\'][data-id=\''+id+'\'').remove();
                $('body').doneLoading();

                if (isOnDetails) {
                    let foundAndClosed = false;
                    $('.reveal-overlay:last:visible').each(function() {
                        if (foundAndClosed === false && $(this).find('form').attr('action').split('/checklist/').length > 0) {
                            $(this).find('.reveal').foundation('close');
                            foundAndClosed = true;
                        }
                    });
                    setTimeout(function() {
                        reload_location_if_needed();
                    }, 500);
                }
            },
            error: function(e) {
                $('body').doneLoading();
                squde_flash("Er ging helaas iets mis.", "alert");
            }
        });
    });

    return false;
}
function view_checklist(id, vars) {
    const $ = jQuery.noConflict();

    if(vars !== undefined && typeof vars === "function") {
        vars = {callback: vars};
    }

    $.squdeAjaxPopup({
        url: '/checklist/view/'+id,
        onOpen: function(elm, popup) {
            init_checklist_selectors(elm, popup);

            elm.find('form').ajaxFormSubmit(function(data){
                if(vars === undefined || vars.callback === undefined) {
                    reload_location_if_needed();
                } else {
                    $('body').doneLoading();
                    vars.callback(data, elm, popup);
                }
            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.", "alert");
            }.bind([elm,popup]),function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}
function is_on_checklist_details() {
    const $ = jQuery.noConflict();

    return $('.reveal-overlay:visible:last').find('form:first').attr('action').split('/checklist/').length > 1;
}
function fill_in_checklist_for_appointment(id) {
    const $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/checklist/submissionForAppointment/' + id,
        onOpen: function(elm, popup) {
            elm.find('form').ajaxFormSubmit(function(data){
                reload_location_if_needed(document.closeWindow);
            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.", "alert");
            }.bind([elm,popup]),function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}
